import { Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';

import { LabelPerfPageLayout } from '~/modules/label-perf/components/LabelPerfPageLayout';

import { DataFreshness } from './containers/DataFreshness/DataFreshness';
import { LabelPerf } from './containers/LabelPerf/LabelPerf';
import { LabelMapping } from './containers/Mapping';

/**
 * Top-level router combining module-level routers
 */
function Router() {
  return (
    <Suspense>
      <Routes>
        <Route element={<LabelPerfPageLayout />}>
          <Route path="*" element={<LabelPerf />} />
          <Route path="mapping" element={<LabelMapping />} />
          <Route path="data-freshness" element={<DataFreshness />} />
        </Route>
      </Routes>
    </Suspense>
  );
}

Router.displayName = 'LabelPerfRouter';

export { Router };
